<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="finance" pageId="cash-advances-self-service" color="white"></help-link>
                    <v-btn v-if="hasAddRights" fab dark small color="primary" title="Create Cash Advances" @click="showAdd">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-card class="elavation-1 mt-5"> 
                <v-toolbar flat height="45px">
                    <div :class="isMobile ? 'wp-60 mb-10' : 'wp-30 mb-10'">
                        <v-text-field v-model="search" append-icon="search" label="Search type, status" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile ? [] : headers"
                    :items="cash_advances_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                    :hide-headers="isMobile"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">

                        <!-- mobile view -->
                        <tr v-if="isMobile" @click="viewDetails(props.item.cashAdvancesId)">
                            <td :colspan="headers.length" class="pa-1">
                                <v-card class="elevation-1">
                                    <v-layout row wrap align-center class="section-layout">
                                        <v-flex xs12 class="text-xs-left mt-5 mb-2">
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Type</div>
                                                    <div>{{props.item.cashAdvanceType}}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Payment Start Date</div>
                                                    <div>{{props.item.paymentStart | moment('MMM DD, YYYY')}}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Cash Advance Amount</div>
                                                    <div>₱{{numFormat.formatNumber(props.item.totalAmount)}}</div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Total Paid</div>
                                                    <div>₱{{numFormat.formatNumber(getTotalPaid(props.item.paymentSchedule))}}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Status</div>
                                                    <div :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</div>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </td>
                        </tr>

                        <!-- desktop view -->
                        <tr v-else @click="viewDetails(props.item.cashAdvancesId)" title="Click to view details" class="clickable">
                            <td>{{props.item.cashAdvanceType}}</td>
                            <td>{{props.item.paymentStart | moment('MMM DD, YYYY')}}</td>
                            <td>₱{{numFormat.formatNumber(props.item.totalAmount)}}</td>
                            <td>₱{{numFormat.formatNumber(getTotalPaid(props.item.paymentSchedule))}}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>

        <v-dialog v-model="dialogAddEdit" width="700" persistent>   
            <add-edit ref="addEditRef" :dialogAddEdit.sync="dialogAddEdit" @send="viewDetails"></add-edit>
        </v-dialog>
    </v-layout> 
</template>

<script>

import cashadvancesApi from '@/api/cashadvances'
import commonfn from '@/common/functions'       //for refactor
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import { hasAddRights } from '@/helpers/access-permissions'

export default {     
    name: 'MyCashAdvances',
    metaInfo: {
        title: 'My Cash Advances',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create My Cash Advances' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-edit': () => import('@/components/CashAdvances/AddEditCashAdvances')
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            numFormat,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Type',align: 'left',value: 'cashAdvanceType', width: '20%', sortable:true},
                {text: 'Payment Start Date',align: 'left',value: 'paymentStart',  width: '15%', sortable:true},
                {text: 'Cash Advance Amount',align: 'left',value: 'totalAmount',  width: '15%', sortable:true},
                {text: 'Total Paid',align: 'left',value: 'paymentSchedule',  width: '15%', sortable:true},
                {text: 'Status',align: 'left',value: 'status',  width: '15%', sortable:true},
            ],
            error: false,
            errorMessage: '',
            loading: false,
            dialogAddEdit: false,
            search: null,
            cash_advances: []
        }
    },
    methods: {
        viewDetails(cashAdvancesId) {
            this.$router.push(`/finance/mycashadvances/${cashAdvancesId}`)
        },
        showAdd() {
            const data = {
                isRequestForOtherUser: false,
                pageKey: pageKeys.my_cash_advances
            }
            this.$refs.addEditRef.setAdd(data)
            this.dialogAddEdit = true
        },
        getTotalPaid(data){
            var paidSchedule = data.filter(x => {
                return x.paidOn != null && x.status == commonfn.getStatusCode('Paid')
            })
            if (paidSchedule.length>0) return paidSchedule.map(x => x.amountDue).reduce((prev,next) => prev+next)
            else return 0
        },
        async getMyCashAdvances(show_loading) {
            try {
                this.loading = show_loading
                const response = await cashadvancesApi.getMyCashAdvances()
                if (response.status == 200) {
                    this.cash_advances = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'My Cash Advances'
        })

        this.getMyCashAdvances(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        cash_advances_filtered() {
            var temp = this.cash_advances
            if (this.search) {
                temp = temp.filter(item => {
                    const searchLower = this.search.toLowerCase()
                    const typeMatch = item.cashAdvanceType.toLowerCase().includes(searchLower)
                    const statusMatch = commonfn.getStatusDescription(item.status).toLowerCase().includes(searchLower)

                    return typeMatch || statusMatch
                })
            }

            // Add computed fields
            temp = temp.map(e => {
                const hasSchedule = Array.isArray(e.paymentSchedule) && e.paymentSchedule.length > 0;
                const paymentStartDate = hasSchedule ? e.paymentSchedule[0].dueOn : null;
                const lastPaymentDate = hasSchedule ? e.paymentSchedule[e.paymentSchedule.length - 1].dueOn : null;

                return {
                    ...e,
                    paymentStartDate,
                    lastPaymentDate,
                    Status: e.paidOn ? 'Paid' : 'Unpaid'
                }
            })
            return temp
        },
        isMobile() {
            return window.innerWidth < 600
        },
        hasAddRights() {
            return hasAddRights(this.$router.currentRoute.path)
        },
    }
}
</script>
<style scoped>
.section-layout {
    padding:0px 23px 0px 23px;
}
</style>